import { STORAGE_FOLDERS, uploadImage } from '@/firebase';
import { cloneDeep } from 'lodash';
import { synthesize } from 'redux-dispatcher';

export const API_SIGNALR_URL = process.env.REACT_APP_API_SIGNALR;

const mapDispatchToAC = {
  // Service
  setState: (state, value) => ({ state, value }),
  resetData: () => ({}),
  getSymptomsList:
    () =>
    async ({ Api }) => {
      const { result, status } = await Api.get(`symptom-suggestions`, {
        isFromWebConsult: true,
      });
      status === 200 && teleConsultNowDispatcher.setState('symptoms', result);
    },

  getCorporatePlans:
    () =>
    async ({ Api }) => {
      const { result, status } = await Api.get(`corporate-plans`);
      status === 200 &&
        teleConsultNowDispatcher.setState('corporatePlans', result);
    },

  getAllClinics:
    () =>
    async ({ Api }) => {
      const { result, status } = await Api.post(
        'clinics/filter?clinicStatus=Open',
        {}
      );
      status === 200 &&
        teleConsultNowDispatcher.setState('clinics', result?.list);
    },

  checkValidPromotionsCode:
    (code, onSuccess) =>
    async ({ Api }) => {
      const { status, result } = await Api.get('promotions/validity', {
        code,
      });
      if (status === 200) {
        onSuccess && onSuccess(result);
      }
    },
  checkWaitingRoomStatus:
    () =>
    async ({ Api }) => {
      const { status, rawData } = await Api.get(
        'patients/waiting-room-status',
        {},
        false,
        true,
        API_SIGNALR_URL
      );
      if (status === 200) {
        teleConsultNowDispatcher.setState('waitingRoomStatus', rawData);
      }
    },

  checkAvailableService:
    (onSuccess) =>
    async ({ Api }) => {
      const { status, result } = await Api.get(
        'functions-configurations?function=TeleConsult'
      );
      if (status === 200) {
        onSuccess && onSuccess(result);
      }
    },

  joinPTWaitingRoom:
    (payload, onSuccess) =>
    async ({ Api }) => {
      // The plan itself is created by addCorporatePlan; this endpoint only
      // needs to know which one was picked, so the name and the two photos are
      // dropped rather than uploaded again. The id goes up whenever there is
      // one, regardless of the yes/no toggle, and is left out when there is not.
      const {
        corperatePlan,
        frontCorperatePlan,
        backCorperatePlan,
        corporatePlanId,
        ...rest
      } = cloneDeep(payload);
      const body = corporatePlanId ? { ...rest, corporatePlanId } : rest;

      const { status } = await Api.post(
        'patients/join-waiting-room',
        body,
        '',
        false,
        true,
        false,
        API_SIGNALR_URL
      );
      if (status === 200) {
        onSuccess && onSuccess();
      }
    },

  leaveWaitingRoom:
    (onSuccess) =>
    async ({ Api }) => {
      const { status } = await Api.delete(
        'patients/leave-waiting-room',
        '',
        false,
        true,
        API_SIGNALR_URL
      );
      if (status === 200) {
        onSuccess && onSuccess();
      }
    },
  updateLocalStream: (streams) => ({ streams }),
  updateRemoteStream: (streams) => ({ streams }),
  addCorporatePlan:
    (payload, onSuccess, onFail) =>
    async ({ Api }) => {
      const body = cloneDeep(payload);

      if (payload.frontCorperatePlan.constructor === File) {
        const fontUrl = await uploadImage(
          payload.frontCorperatePlan,
          false,
          STORAGE_FOLDERS.corporatePlanPhoto
        );
        body.frontCorperatePlan = fontUrl;
      }
      if (payload.backCorperatePlan.constructor === File) {
        const backCurl = await uploadImage(
          payload.backCorperatePlan,
          false,
          STORAGE_FOLDERS.corporatePlanPhoto
        );
        body.backCorperatePlan = backCurl;
      }
      const { result, status } = await Api.post('corporate-plans', {
        name: body.corperatePlan,
        frontPhoto: body.frontCorperatePlan,
        backPhoto: body.backCorperatePlan,
      });
      if (status === 200) {
        // Hand the new plan's id back so the caller can pass it to
        // join-waiting-room, which identifies the plan by id only.
        onSuccess && onSuccess(result?.id || result);
      } else {
        onFail && onFail();
      }
    },
};

const teleConsultNowDispatcher = synthesize('teleConsultNow', mapDispatchToAC);
export default teleConsultNowDispatcher;
